export enum ExternalUrlFormIds {
  urlTemplate = 'urlTemplate',
  disabled = 'disabled',
  language = 'language'
}

export const languageValidationParameter = 'description';
export const longDescriptionValidationParameter = 'longDescription';
export const maxDescriptionLength = 254;
export const maxLongDescriptionLength = 4000;
